import React, { Component } from 'react';

import ClrSelect from '../ClrSelect';

import './ShowenConf.css';

class ShowenConf extends Component {

  constructor() {
    super();
    this.state = {
      size: 0,
      img_sill: '',
      img_wall: '',
    };
    this.handleResize = this.handleResize.bind(this);
  }

  componentDidMount() {
    window.addEventListener('resize', this.handleResize);
    window.addEventListener('orientationchange', this.handleResize);
    this.handleResize();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
    window.removeEventListener('orientationchange', this.handleResize);
  }

  handleResize() {
    this.setState({
      size: Math.min(window.innerWidth, window.innerHeight, 575)
    });
  }

  render() {

    const {img_sill, img_wall} = this.state;

    return (
      <div className="ShowenConf-div">
        <img src="/img/osnova-2.png" className="ShowenConf-img" alt="" style={{width: this.state.size}} />
        {img_sill && <img src={img_sill} className="ShowenConf-img" alt="" style={{width: this.state.size}} />}
        {img_wall && <img src={img_wall} className="ShowenConf-img" alt="" style={{width: this.state.size}} />}
        <img src="/img/osnova-1.png" className="ShowenConf-img" alt="" style={{width: this.state.size}} />
        <ClrSelect
          top = {this.state.size * 0.75}
          clr_sill = {(img) => {
            this.setState({img_sill: img.replace('67', '').toLocaleLowerCase()})
          }}
          clr_wall = {(img) => {
            this.setState({img_wall: img.replace('67', '').toLocaleLowerCase()})
          }}
        />
      </div>
    );
  }

}

export default ShowenConf;



// WEBPACK FOOTER //
// ./src/ShowenConf/ShowenConf.js